import { Campaign, Template, Workflow } from '@iterable/deprecated_react_components';
import { EMAIL, SMS } from 'constants/messageMediums';
import { TemplateSource } from 'constants/templateTypes';
import styled from 'styled-components';
import { spacing } from 'ui/theme';
import { setEmptyTileStateText } from '../utils';

const Container = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 60px;
`;

const IconContainer = styled.div`
  margin-bottom: ${spacing.plusQuarter};
`;

const Statement = styled.p`
  font-size: 18px;
`;
const SemiBoldStatement = styled(Statement)`
  font-weight: 600;
`;

const Anchor = styled.a`
  color: #2e8ece;
`;

type EmptyTileStateProps = {
  query?: string; // filter query
  messageMedium?: string;
  selectedTab?: TemplateSource;
  smsSendersExist?: boolean;
  authedEmailsExist?: boolean;
};

export const EmptyTileState = ({
  authedEmailsExist = false,
  messageMedium = EMAIL,
  selectedTab = TemplateSource.Base,
  smsSendersExist = false,
  query = '',
}: EmptyTileStateProps) => {
  const showSmsSendersMessage = messageMedium === SMS && !smsSendersExist;
  const showEmailSendersMessage = messageMedium === EMAIL && !authedEmailsExist;
  const showUsualMessage = !showSmsSendersMessage && !showEmailSendersMessage;

  const { text, subtext } = setEmptyTileStateText(messageMedium, selectedTab, query);

  const isWorkflow = selectedTab === TemplateSource.Workflow;
  const isCampaign = selectedTab === TemplateSource.Campaign;
  const isDefault = !isWorkflow && !isCampaign;

  return (
    <Container
      data-test="template-picker-empty-tile-state"
      role="tabpanel"
      aria-labelledby={selectedTab}
    >
      <IconContainer>
        {isWorkflow && <Workflow />}
        {isCampaign && <Campaign />}
        {isDefault && <Template />}
      </IconContainer>
      {showUsualMessage && (
        <>
          <SemiBoldStatement>{text}</SemiBoldStatement>
          <Statement>{subtext}</Statement>
        </>
      )}
      {showSmsSendersMessage && (
        <>
          <SemiBoldStatement>
            You must have at least one short code or messaging service configured to send SMS
            messages.
          </SemiBoldStatement>
          <Statement>Please contact your account manager for more information.</Statement>
          <Statement>
            You can learn more about setting up SMS messages&nbsp;
            <Anchor href="https://support.iterable.com/hc/en-us/articles/211970843-SMS-overview">
              here
            </Anchor>
            .
          </Statement>
        </>
      )}
      {showEmailSendersMessage && (
        <>
          <SemiBoldStatement>
            A verified sender is required to create a template or campaign.
          </SemiBoldStatement>
          <Statement>
            Click <Anchor href="/settings/senders">here</Anchor> to set up a sender.
          </Statement>
        </>
      )}
    </Container>
  );
};
